import { useCallback, useEffect, useRef, useState } from 'react';
import { dimOrder, QUESTIONS, theme } from '../data';
import { Card, PendingSpin } from '../types';

export interface UsageInfo {
  total: number;
  latest: Card;
  where: string;
}

export interface WheelSpinState {
  pendingSpin: PendingSpin | null;
  wheelRotation: number;
  spinning: boolean;
  spin: () => void;
  resetSpin: () => void;
  findUsage: (q: string) => UsageInfo | null;
}

export const useWheelSpin = (cards: Card[]): WheelSpinState => {
  const [pendingSpin, setPendingSpin] = useState<PendingSpin | null>(null);
  const [wheelRotation, setWheelRotation] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  const findUsage = useCallback(
    (q: string): UsageInfo | null => {
      const matches = cards.filter(c => c.q === q);
      if (!matches.length) return null;
      const sorted = [...matches].sort(
        (a, b) => b.createdAt.getTime() - a.createdAt.getTime(),
      );
      const top = sorted[0];
      const where = !top.finalized ? 'gerade in Arbeit' : 'auf dem Board';
      return { total: matches.length, latest: top, where };
    },
    [cards],
  );

  const spin = useCallback((): void => {
    if (spinning) return;
    const fromId = dimOrder[Math.floor(Math.random() * dimOrder.length)];
    const pool = QUESTIONS[fromId];
    const q = pool[Math.floor(Math.random() * pool.length)].text;
    setPendingSpin({ q, from: fromId });
    setSpinning(true);
    const spins = 4 + Math.floor(Math.random() * 2);
    const target =
      360 * spins - theme(fromId).angle + (Math.random() * 30 - 15);
    setWheelRotation(prev => prev + (360 - (prev % 360)) + target);
    timeoutRef.current = setTimeout(() => {
      setSpinning(false);
    }, 2650);
  }, [spinning]);

  const resetSpin = useCallback((): void => {
    setPendingSpin(null);
  }, []);

  return { pendingSpin, wheelRotation, spinning, spin, resetSpin, findUsage };
};
